// extracted by mini-css-extract-plugin
export var cta = "question-card-module--cta--2xS34";
export var meta = "question-card-module--meta--1I3si";
export var mockup = "question-card-module--mockup--FGRaG";
export var paragraph = "question-card-module--paragraph--33sQo";
export var questionCard = "question-card-module--question-card--2Phr7";
export var sparkle = "question-card-module--sparkle--3fXLv";